import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchMrdXmlAnalysis = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdXmlAnalysis',
    stub: config.useStubbedEndpoints,
  });
  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchMrdXmlAnalysis;
